// import React, { useState, useEffect } from 'react';
// import './navbarstyle.css';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faHouse, faInfoCircle, faTools, faEnvelope, faBars, faTimes, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
// import { jwtDecode } from 'jwt-decode';
// import { Textfit } from 'react-textfit';
// import userpic from './images/Usericon.png';
// import profile from './images/profile.png';
// import setting from './images/setting.png';
// import help from './images/help.png';
// import Logout from './images/logout.png';
// import { URL } from '../config';

// const Navbar = () => {
//   const [clicked, setClicked] = useState(false);
//   const [user, setUser] = useState(null);
//   const [dropdownVisible, setDropdownVisible] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, []);

//   const fetchUserDetails = async (userId) => {
//     try {
//       // Extract numeric ID by removing the "user-" or "servitor-" prefix
//       const extractedUserId = userId.startsWith('user-') ? userId.split('user-')[1] : userId;
  
//       const response = await fetch(`${URL}/user/${extractedUserId}`);
//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setUser(null);
//     }
//   };
  

//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//     window.location.href = '/login';
//   };

//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   return (
//     <nav className='NavbarItems'>
//       <h1 className='navbar-logo'>HelpNao</h1>
//       <div className='menu-icons' onClick={() => setClicked(!clicked)}>
//         {clicked ? <FontAwesomeIcon icon={faTimes} className='icons' /> : <FontAwesomeIcon icon={faBars} className='icons' />}
//       </div>
//       <ul className={clicked ? "nav-menu active" : "nav-menu"}>
//         <li>
//           <Link className='navlinks' to="/home"><FontAwesomeIcon className="icons" icon={faHouse} />
//             <span>Home</span></Link>
//         </li>
//         <li>
//           <Link className='navlinks' to="/about"><FontAwesomeIcon className="icons" icon={faInfoCircle} />
//             <span>About</span></Link>
//         </li>
//         <li>
//           <Link className='navlinks' to="/"><FontAwesomeIcon className="icons" icon={faTools} />
//             <span>Services</span></Link>
//         </li>
//         <li>
//           <Link className='navlinks' to="/"><FontAwesomeIcon className="icons" icon={faEnvelope} />
//             <span>Contact</span></Link>
//         </li>
//         {user ? (
//           <li className='navlinks profile' onClick={toggleDropdown}>
//             <img src={user && user.image ? `${URL}${user.image}` : userpic} alt="User" className="user-pic" />
//             <FontAwesomeIcon 
//               icon={dropdownVisible ? faCaretUp : faCaretDown} 
//               className="dropdown-icon" 
//             />
//             {dropdownVisible && (
//               <div className='sub-menu-wrap active' id='subMenu'>
//                 <div className='sub-menu'>
//                   <div className='user-info'>
//                     <img src={user && user.image ? `${URL}${user.image}` : userpic} alt="User" />
//                     <Textfit mode="single" max={16}>
//                       {user.FirstName + ' ' + user.LastName}
//                     </Textfit>
//                   </div>
//                   <hr />
//                   <Link to="/profile" className='sub-menu-link'>
//                     <img src={profile} alt="Profile" />
//                     <p>Profile</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className='sub-menu-link'>
//                     <img src={setting} alt="Settings" />
//                     <p>Setting & Privacy</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className='sub-menu-link'>
//                     <img src={help} alt="Help" />
//                     <p>Help & Support</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className='sub-menu-link' onClick={handleLogout}>
//                     <img src={Logout} alt="Logout" />
//                     <p>Logout</p>
//                   </Link>
//                 </div>
//               </div>
//             )}
//           </li>
//         ) : (
//           <Link to="/login"><button>Log in</button></Link>
//         )}
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;






// ******* All is working and okay checked last (17-06-25) ******* //
// import React, { useState, useEffect, useRef } from 'react';
// import './navbarstyle.css';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faHouse,
//   faInfoCircle,
//   faTools,
//   faEnvelope,
//   faBars,
//   faTimes,
//   faCaretDown,
//   faWrench,
//   faBroom,
//   faFaucet,
// } from '@fortawesome/free-solid-svg-icons';
// import { jwtDecode } from 'jwt-decode';
// import { Textfit } from 'react-textfit';
// import userpic from './images/Usericon.png';
// import profile from './images/profile.png';
// import setting from './images/setting.png';
// import help from './images/help.png';
// import Logout from './images/logout.png';
// import { URL } from '../config';
// import NotificationDropdown from '../Pages/User/Notification/NotificationDropdown';

// const Navbar = () => {
//   const [sideMenuOpen, setSideMenuOpen] = useState(false);
//   const [user, setUser] = useState(null);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  
//   const dropdownRef = useRef(null);

//   // On mount, check token & fetch user
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, []);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target)
//       ) {
//         setDropdownVisible(false);
//       }
//     };

//     if (dropdownVisible) {
//       document.addEventListener("mousedown", handleClickOutside);
//     } else {
//       document.removeEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownVisible]);

//   // Fetch user details from API
//   const fetchUserDetails = async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith('user-')
//         ? userId.split('user-')[1]
//         : userId;
//       const response = await fetch(`${URL}/user/${extractedUserId}`);
//       if (response.ok) {
//         const userData = await response.json();
//         setUser(userData);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setUser(null);
//     }
//   };

//   // Handle Logout
//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//     window.location.href = '/login';
//   };

//   // Toggle user dropdown
//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   // Toggle sidebar menu
//   const toggleSideMenu = () => {
//     setSideMenuOpen(!sideMenuOpen);
//   };

//   // Toggle services dropdown
//   const toggleServicesDropdown = () => {
//     setServicesDropdownOpen(!servicesDropdownOpen);
//   };

//   // Close services dropdown when a service is selected
//   const handleServiceSelect = () => {
//     setServicesDropdownOpen(false);
//     setSideMenuOpen(false);
//   };


//   return (
//     <nav className="usernavbar">
//       {/* Left: Hamburger + Logo */}
//       <div className="usernavbar-left">
//         <div className="usernavbar-menu-icon" onClick={toggleSideMenu}>
//           {sideMenuOpen ? (
//             <FontAwesomeIcon icon={faTimes} className="usernavbar-icon" />
//           ) : (
//             <FontAwesomeIcon icon={faBars} className="usernavbar-icon" />
//           )}
//         </div>
//         <h1 className="usernavbar-logo">HelpNao</h1>
//       </div>

//       {/* Right: User icon or Login button */}
//       <div className="usernavbar-right" ref={dropdownRef}>
//         {/* <NotificationDropdown /> */}
//         {user && <NotificationDropdown />}
//         {user ? (
//           <div className="usernavbar-profile" onClick={toggleDropdown}>
//             <img
//               src={user?.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               className="usernavbar-userpic"
//             />
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-dropdown-icon ${dropdownVisible ? "open" : ""}`}
//             />
//             {dropdownVisible && (
//               <div className="usernavbar-submenu-wrap active">
//                 <div className="usernavbar-submenu">
//                   {/* User Info Section */}
//                   <div className="usernavbar-user-info">
//                     <img
//                       src={user?.image ? `${URL}${user.image}` : userpic}
//                       alt="User"
//                       className="usernavbar-submenu-userpic"
//                     />
//                     <div className="usernavbar-user-details">
//                       <Textfit mode="single" max={16}>
//                         {user.FirstName + " " + user.LastName}
//                       </Textfit>
//                       {user.Email && (
//                         <p className="usernavbar-submenu-email">{user.Email}</p>
//                       )}
//                     </div>
//                   </div>
//                   <hr />

//                   {/* Menu Items */}
//                   <Link to="/profile" className="usernavbar-submenu-link">
//                     <img src={profile} alt="Profile" />
//                     <p>Profile</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={setting} alt="Settings" />
//                     <p>Setting &amp; Privacy</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={help} alt="Help" />
//                     <p>Help &amp; Support</p>
//                     <span>&gt;</span>
//                   </Link>
//                   <hr />

//                   {/* Logout */}
//                   <div
//                     className="usernavbar-submenu-link usernavbar-submenu-logout"
//                     onClick={handleLogout}
//                   >
//                     <img src={Logout} alt="Logout" />
//                     <p>Logout</p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         ) : (
//           <Link to="/login">
//             <button className="usernavbar-login-btn">Log in</button>
//           </Link>
//         )}
//       </div>

//       {/* Sidebar Menu */}
//       <ul
//         className={
//           sideMenuOpen ? "usernavbar-side-menu open" : "usernavbar-side-menu"
//         }
//       >
//         <li>
//           <Link className="usernavbar-link" to="/home" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} />
//             <span>Home</span>
//           </Link>
//         </li>
//         {/* <li>
//           <Link className="usernavbar-link" to="/" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faTools} />
//             <span>Services</span>
//           </Link>
//         </li> */}
//         <li>
//                   <div
//                     className={`usernavbar-link ${servicesDropdownOpen ? "active" : ""}`}
//                     onClick={toggleServicesDropdown}
//                   >
//                     <FontAwesomeIcon className="usernavbar-icon" icon={faTools} />
//                     <span>Services</span>
//                     <FontAwesomeIcon
//                       icon={faCaretDown}
//                       className={`usernavbar-services-dropdown-icon ${
//                         servicesDropdownOpen ? "open" : ""
//                       }`}
//                     />
//                   </div>
//                   {servicesDropdownOpen && (
//                     <ul className={`usernavbar-services-dropdown ${servicesDropdownOpen ? "open" : ""}`}>
//                       <li>
//                         <Link
//                           to="/services/electrician"
//                           className="usernavbar-services-link"
//                           onClick={handleServiceSelect}
//                         >
//                           <FontAwesomeIcon
//                             className="usernavbar-services-icon"
//                             icon={faWrench}
//                           />
//                           <span>Electrician</span>
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           to="/services/home-cleaning"
//                           className="usernavbar-services-link"
//                           onClick={handleServiceSelect}
//                         >
//                           <FontAwesomeIcon
//                             className="usernavbar-services-icon"
//                             icon={faBroom}
//                           />
//                           <span>Home Cleaning</span>
//                         </Link>
//                       </li>
//                       <li>
//                         <Link
//                           to="/services/plumber"
//                           className="usernavbar-services-link"
//                           onClick={handleServiceSelect}
//                         >
//                           <FontAwesomeIcon
//                             className="usernavbar-services-icon"
//                             icon={faFaucet}
//                           />
//                           <span>Plumber</span>
//                         </Link>
//                       </li>
//                     </ul>
//                   )}
//                 </li>
                
//         <li>
//           <Link
//             className="usernavbar-link"
//             to="/about"
//             onClick={toggleSideMenu}
//           >
//             <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} />
//             <span>About</span>
//           </Link>
//         </li>
//         <li>
//           <Link className="usernavbar-link" to="/" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faEnvelope} />
//             <span>Contact</span>
//           </Link>
//         </li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;











// ******** Add Translator EN-BN language New (17-06-25) ********** //
// New update with Translator
// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import './navbarstyle.css';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faHouse,
//   faInfoCircle,
//   faTools,
//   faEnvelope,
//   faBars,
//   faTimes,
//   faCaretDown,
//   faWrench,
//   faBroom,
//   faFaucet,
//   faGlobe // Line 14: Added faGlobe for language toggle
// } from '@fortawesome/free-solid-svg-icons';
// import { jwtDecode } from 'jwt-decode';
// import { Textfit } from 'react-textfit';
// import userpic from './images/Usericon.png';
// import profile from './images/profile.png';
// import setting from './images/setting.png';
// import help from './images/help.png';
// import Logout from './images/logout.png';
// import { URL } from '../config';
// import NotificationDropdown from '../Pages/User/Notification/NotificationDropdown';
// import { useTranslation } from 'react-i18next'; // Line 26: Added for i18n
// import axios from 'axios'; // Line 27: Added for consistent API calls

// const Navbar = () => {
//   const { t, i18n } = useTranslation(); // Line 30: Initialize i18n
//   const [sideMenuOpen, setSideMenuOpen] = useState(false);
//   const [user, setUser] = useState(null);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
//   const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false); // Line 35: Added for language dropdown state
//   const dropdownRef = useRef(null);
//   const languageDropdownRef = useRef(null); // Line 37: Added for language dropdown ref

//   // Line 39-58: Memoized fetchUserDetails to fix ESLint warning
//   const fetchUserDetails = useCallback(async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith('user-')
//         ? userId.split('user-')[1]
//         : userId;
//       const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//         params: { lang: i18n.language } // Pass language for translated data
//       });
//       if (response.status === 200) {
//         const userData = response.data;
//         setUser(userData);
//         if (userData.language && userData.language !== i18n.language) {
//           i18n.changeLanguage(userData.language); // Sync with user preference
//         }
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setUser(null);
//     }
//   }, [i18n]);

//   // Line 60-66: Updated useEffect with fetchUserDetails dependency
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, [fetchUserDetails]);

//   // Line 68-85: Updated useEffect to handle both dropdowns
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownVisible(false);
//       }
//       if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
//         setLanguageDropdownOpen(false);
//       }
//     };
//     if (dropdownVisible || languageDropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownVisible, languageDropdownOpen]);

//   // Line 87-94: Added handleLanguageChange
//   const handleLanguageChange = async (lang) => {
//     i18n.changeLanguage(lang);
//     setLanguageDropdownOpen(false);
//     if (user) {
//       try {
//         await axios.put(`${URL}/user/${user.Id}/language`, { language: lang }, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//         });
//       } catch (error) {
//         console.error('Error updating language:', error);
//       }
//     }
//   };

//   // Line 96-101: Handle Logout
//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//     window.location.href = '/login';
//   };

//   // Line 103-105: Toggle user dropdown
//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   // Line 107-109: Toggle sidebar menu
//   const toggleSideMenu = () => {
//     setSideMenuOpen(!sideMenuOpen);
//   };

//   // Line 111-113: Toggle services dropdown
//   const toggleServicesDropdown = () => {
//     setServicesDropdownOpen(!servicesDropdownOpen);
//   };

//   // Line 115-118: Close services dropdown when a service is selected
//   const handleServiceSelect = () => {
//     setServicesDropdownOpen(false);
//     setSideMenuOpen(false);
//   };

//   // Line 120: Added aria-label for accessibility
//   const toggleLanguageDropdown = () => {
//     setLanguageDropdownOpen(!languageDropdownOpen);
//   };

//   return (
//     <nav className="usernavbar">
//       {/* Left: Hamburger + Logo */}
//       <div className="usernavbar-left">
//         <div className="usernavbar-menu-icon" onClick={toggleSideMenu}>
//           {sideMenuOpen ? (
//             <FontAwesomeIcon icon={faTimes} className="usernavbar-icon" />
//           ) : (
//             <FontAwesomeIcon icon={faBars} className="usernavbar-icon" />
//           )}
//         </div>
//         <h1 className="usernavbar-logo">{t('navbar.logo')}</h1> {/* Line 137: Use translation */}
//       </div>

//       {/* Right: Language switcher, Notifications, User icon or Login button */}
//       <div className="usernavbar-right" ref={dropdownRef}>
//         {/* Language Switcher: Lines 141-160 */}
//         <div className="usernavbar-language" ref={languageDropdownRef}>
//           <div
//             className="usernavbar-language-toggle"
//             onClick={toggleLanguageDropdown}
//             aria-label={`Select language, current: ${t(`navbar.${i18n.language}`)}`} // Accessibility
//           >
//             <FontAwesomeIcon icon={faGlobe} className="usernavbar-icon" />
//             <span>{t(`navbar.${i18n.language}`)}</span>
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-dropdown-icon ${languageDropdownOpen ? "open" : ""}`}
//             />
//           </div>
//           {languageDropdownOpen && (
//             <div className="usernavbar-language-dropdown">
//               <div className="usernavbar-language-option" onClick={() => handleLanguageChange('en')}>
//                 {t('navbar.english')}
//               </div>
//               <div className="usernavbar-language-option" onClick={() => handleLanguageChange('bn')}>
//                 {t('navbar.bangla')}
//               </div>
//             </div>
//           )}
//         </div>

//         {user && <NotificationDropdown />}
//         {user ? (
//           <div className="usernavbar-profile" onClick={toggleDropdown}>
//             <img
//               src={user?.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               className="usernavbar-userpic"
//             />
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-dropdown-icon ${dropdownVisible ? "open" : ""}`}
//             />
//             {dropdownVisible && (
//               <div className="usernavbar-submenu-wrap active">
//                 <div className="usernavbar-submenu">
//                   {/* User Info Section */}
//                   <div className="usernavbar-user-info">
//                     <img
//                       src={user?.image ? `${URL}${user.image}` : userpic}
//                       alt="User"
//                       className="usernavbar-submenu-userpic"
//                     />
//                     <div className="usernavbar-user-details">
//                       <Textfit mode="single" max={16}>
//                         {user.FirstName + " " + user.LastName}
//                       </Textfit>
//                       {user.Email && (
//                         <p className="usernavbar-submenu-email">{user.Email}</p>
//                       )}
//                     </div>
//                   </div>
//                   <hr />

//                   {/* Menu Items */}
//                   <Link to="/profile" className="usernavbar-submenu-link">
//                     <img src={profile} alt="Profile" />
//                     <p>{t('navbar.profile')}</p> {/* Line 197: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={setting} alt="Settings" />
//                     <p>{t('navbar.settings')}</p> {/* Line 201: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={help} alt="Help" />
//                     <p>{t('navbar.help')}</p> {/* Line 205: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <hr />

//                   {/* Logout */}
//                   <div
//                     className="usernavbar-submenu-link usernavbar-submenu-logout"
//                     onClick={handleLogout}
//                   >
//                     <img src={Logout} alt="Logout" />
//                     <p>{t('navbar.logout')}</p> {/* Line 215: Use translation */}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         ) : (
//           <Link to="/login">
//             <button className="usernavbar-login-btn">{t('navbar.login')}</button> {/* Line 222: Use translation */}
//           </Link>
//         )}
//       </div>

//       {/* Sidebar Menu */}
//       <ul
//         className={
//           sideMenuOpen ? "usernavbar-side-menu open" : "usernavbar-side-menu"
//         }
//       >
//         <li>
//           <Link className="usernavbar-link" to="/home" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} />
//             <span>{t('navbar.home')}</span> {/* Line 235: Use translation */}
//           </Link>
//         </li>
//         <li>
//           <div
//             className={`usernavbar-link ${servicesDropdownOpen ? "active" : ""}`}
//             onClick={toggleServicesDropdown}
//           >
//             <FontAwesomeIcon className="usernavbar-icon" icon={faTools} />
//             <span>{t('navbar.services')}</span> {/* Line 242: Use translation */}
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-services-dropdown-icon ${
//                 servicesDropdownOpen ? "open" : ""
//               }`}
//             />
//           </div>
//           {servicesDropdownOpen && (
//             <ul className={`usernavbar-services-dropdown ${servicesDropdownOpen ? "open" : ""}`}>
//               <li>
//                 <Link
//                   to="/services/electrician"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faWrench}
//                   />
//                   <span>{t('navbar.electrician')}</span> {/* Line 260: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/home-cleaning"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faBroom}
//                   />
//                   <span>{t('navbar.home_cleaning')}</span> {/* Line 272: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/plumber"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faFaucet}
//                   />
//                   <span>{t('navbar.plumber')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//             </ul>
//           )}
//         </li>
//         <li>
//           <Link
//             className="usernavbar-link"
//             to="/about"
//             onClick={toggleSideMenu}
//           >
//             <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} />
//             <span>{t('navbar.about')}</span> {/* Line 296: Use translation */}
//           </Link>
//         </li>
//         <li>
//           <Link className="usernavbar-link" to="/" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faEnvelope} />
//             <span>{t('navbar.contact')}</span> {/* Line 301: Use translation */}
//           </Link>
//         </li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;


// ***** Upper codes is okay and checked (22-6-25) ***** //








// ***** Navbar Design new with hover effect (22-6-25) ****** //

// update with Translator
// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import './navbarstyle.css';
// import { Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faHouse,
//   faInfoCircle,
//   faTools,
//   faEnvelope,
//   faBars,
//   faTimes,
//   faCaretDown,
//   faWrench,
//   faBroom,
//   faFaucet,
//   faGlobe,
//   faFire,
//   faSnowflake,
//   faFilter,
//   faUserGraduate,
//   faBangladeshiTakaSign
// } from '@fortawesome/free-solid-svg-icons';
// import { jwtDecode } from 'jwt-decode';
// import { Textfit } from 'react-textfit';
// import userpic from './images/Usericon.png';
// import profile from './images/profile.png';
// import setting from './images/setting.png';
// import help from './images/help.png';
// import Logout from './images/logout.png';
// import { URL } from '../config';
// import NotificationDropdown from '../Pages/User/Notification/NotificationDropdown';
// import { useTranslation } from 'react-i18next'; // Line 26: Added for i18n
// import axios from 'axios'; // Line 27: Added for consistent API calls

// const Navbar = () => {
//   const { t, i18n } = useTranslation(); // Line 30: Initialize i18n
//   const [sideMenuOpen, setSideMenuOpen] = useState(false);
//   const [user, setUser] = useState(null);
//   const [dropdownVisible, setDropdownVisible] = useState(false);
//   const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
//   const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false); // Line 35: Added for language dropdown state
//   const dropdownRef = useRef(null);
//   const languageDropdownRef = useRef(null); // Line 37: Added for language dropdown ref

//   // Line 39-58: Memoized fetchUserDetails to fix ESLint warning
//   const fetchUserDetails = useCallback(async (userId) => {
//     try {
//       const extractedUserId = userId.startsWith('user-')
//         ? userId.split('user-')[1]
//         : userId;
//       const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//         params: { lang: i18n.language } // Pass language for translated data
//       });
//       if (response.status === 200) {
//         const userData = response.data;
//         setUser(userData);
//         if (userData.language && userData.language !== i18n.language) {
//           i18n.changeLanguage(userData.language); // Sync with user preference
//         }
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error('Error fetching user details:', error);
//       setUser(null);
//     }
//   }, [i18n]);

//   // Line 60-66: Updated useEffect with fetchUserDetails dependency
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     if (token) {
//       const decodedToken = jwtDecode(token);
//       fetchUserDetails(decodedToken.Id);
//     }
//   }, [fetchUserDetails]);

//   // Line 68-85: Updated useEffect to handle both dropdowns
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setDropdownVisible(false);
//       }
//       if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
//         setLanguageDropdownOpen(false);
//       }
//     };
//     if (dropdownVisible || languageDropdownOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [dropdownVisible, languageDropdownOpen]);

//   // Line 87-94: Added handleLanguageChange
//   const handleLanguageChange = async (lang) => {
//     i18n.changeLanguage(lang);
//     setLanguageDropdownOpen(false);
//     // if (user) {
//     //   try {
//     //     await axios.put(`${URL}/user/${user.Id}/language`, { language: lang }, {
//     //       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//     //     });
//     //   } catch (error) {
//     //     console.error('Error updating language:', error);
//     //   }
//     // }
//   };

//   // Line 96-101: Handle Logout
//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//     window.location.href = '/login';
//   };

//   // Line 103-105: Toggle user dropdown
//   const toggleDropdown = () => {
//     setDropdownVisible(!dropdownVisible);
//   };

//   // Line 107-109: Toggle sidebar menu
//   const toggleSideMenu = () => {
//     setSideMenuOpen(!sideMenuOpen);
//   };

//   // Line 111-113: Toggle services dropdown
//   const toggleServicesDropdown = () => {
//     setServicesDropdownOpen(!servicesDropdownOpen);
//   };

//   // Line 115-118: Close services dropdown when a service is selected
//   const handleServiceSelect = () => {
//     setServicesDropdownOpen(false);
//     setSideMenuOpen(false);
//   };

//   // Line 120: Added aria-label for accessibility
//   const toggleLanguageDropdown = () => {
//     setLanguageDropdownOpen(!languageDropdownOpen);
//   };


//    // --- NEW: close all popups helper (keeps things tidy)
//   const closeAllOverlays = () => {
//     setSideMenuOpen(false);
//     setServicesDropdownOpen(false);
//     setDropdownVisible(false);
//     setLanguageDropdownOpen(false);
//   };

//   // --- NEW: lock/unlock page scroll when side menu is open
//   useEffect(() => {
//     if (sideMenuOpen) {
//       document.documentElement.style.overflow = 'hidden';
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.documentElement.style.overflow = '';
//       document.body.style.overflow = '';
//     }
//     return () => {
//       document.documentElement.style.overflow = '';
//       document.body.style.overflow = '';
//     };
//   }, [sideMenuOpen]);

//   // --- NEW: close drawer with ESC key
//   useEffect(() => {
//     const onKeyDown = (e) => {
//       if (e.key === 'Escape') closeAllOverlays();
//     };
//     if (sideMenuOpen) document.addEventListener('keydown', onKeyDown);
//     return () => document.removeEventListener('keydown', onKeyDown);
//   }, [sideMenuOpen]);

//  return (
//     <nav className="usernavbar">
//       {/* CHANGED: Left section now contains hamburger, logo AND desktop nav links */}
//       <div className="usernavbar-left">
//         {/* CHANGED: Added usernavbar-mobile-only class to hamburger */}
//         <div className="usernavbar-menu-icon usernavbar-mobile-only" 
//         onClick={toggleSideMenu}
//         role="button"
//           aria-label={sideMenuOpen ? 'Close menu' : 'Open menu'}
//           aria-expanded={sideMenuOpen}
//           aria-controls="usernavbar-sidemenu"
//         >
//           {sideMenuOpen ? (
//             <FontAwesomeIcon icon={faTimes} className="usernavbar-icon" />
//           ) : (
//             <FontAwesomeIcon icon={faBars} className="usernavbar-icon" />
//           )}
//         </div>
//         {/* <h1 className="usernavbar-logo">{t('navbar.logo')}</h1> */}

//         <Link to="/home" className="usernavbar-logo-link">
//           <h1 className="usernavbar-logo">{t('navbar.logo')}</h1>
//         </Link>

//         {/* CHANGED: Desktop nav links moved to left section beside logo */}
//         <div className="usernavbar-desktop-nav-container">
//           <ul className="usernavbar-desktop-nav">
//             <li>
//               <Link className="usernavbar-desktop-link" to="/home">
//                 {/* <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} /> */}
//                 <span>{t('navbar.home')}</span>
//               </Link>
//             </li>
//             <li className="usernavbar-desktop-services">
//               <div
//                 className={`usernavbar-desktop-link ${servicesDropdownOpen ? "active" : ""}`}
//                 onClick={toggleServicesDropdown}
//               >
//                 {/* <FontAwesomeIcon className="usernavbar-icon" icon={faTools} /> */}
//                 <span>{t('navbar.services')}</span>
//                 <FontAwesomeIcon
//                   icon={faCaretDown}
//                   className={`usernavbar-services-dropdown-icon ${
//                     servicesDropdownOpen ? "open" : ""
//                   }`}
//                 />
//               </div>
//               {/* CHANGED: New dropdown with unique class usernavbarlinks-dropdown */}
//               {servicesDropdownOpen && (
//                 <ul className="usernavbarlinks-dropdown">
//                   <li>
//                     <Link
//                       to="/services/electrician"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faWrench}
//                       /> */}
//                       <span>{t('navbar.electrician')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/home-cleaning"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faBroom}
//                       /> */}
//                       <span>{t('navbar.home_cleaning')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/plumber"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faFaucet}
//                       /> */}
//                       <span>{t('navbar.plumber')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/gas-chula"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faFaucet}
//                       /> */}
//                       <span>{t('navbar.gas_chula')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/ac-service"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faFaucet}
//                       /> */}
//                       <span>{t('navbar.ac_service')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/filter"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faFaucet}
//                       /> */}
//                       <span>{t('navbar.filter')}</span>
//                     </Link>
//                   </li>
//                   <li>
//                     <Link
//                       to="/services/tutor-service"
//                       className="usernavbarlinks-dropdown-link"
//                       onClick={handleServiceSelect}
//                     >
//                       {/* <FontAwesomeIcon
//                         className="usernavbarlinks-dropdown-icon"
//                         icon={faFaucet}
//                       /> */}
//                       <span>{t('navbar.tutor_service')}</span>
//                     </Link>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             <li>
//               <Link className="usernavbar-desktop-link usernavbar-cta" to="/earnwithHelpNao">
//                 {t('navbar.start_earning') || 'Start earning'}
//               </Link>
//             </li>


//             <li>
//               <Link className="usernavbar-desktop-link" to="/about">
//                 {/* <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} /> */}
//                 <span>{t('navbar.about')}</span>
//               </Link>
//             </li>
//             <li>
//               <Link className="usernavbar-desktop-link" to="/helpfaqs">
//                 {/* <FontAwesomeIcon className="usernavbar-icon" icon={faEnvelope} /> */}
//                 <span>{t('navbar.faq')}</span>
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </div>

//       {/* Right: Language switcher, Notifications, User icon or Login button */}
//       <div className="usernavbar-right" ref={dropdownRef}>
//         {/* Language Switcher: Lines 141-160 */}
//         <div className="usernavbar-language" ref={languageDropdownRef}>
//           <div
//             className="usernavbar-language-toggle"
//             onClick={toggleLanguageDropdown}
//             aria-label={`Select language, current: ${t(`navbar.${i18n.language}`)}`} // Accessibility
//           >
//             <FontAwesomeIcon icon={faGlobe} className="usernavbar-icon" />
//             {/* <span>{t(`navbar.${i18n.language}`)}</span> */}
//             {/* for remove navbar and set en and bn */}
            
//             {/* <span>{i18n.language}</span>   */}
//             <span>{i18n.language.toUpperCase()}</span>  
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-dropdown-icon ${languageDropdownOpen ? "open" : ""}`}
//             />
//           </div>
//           {languageDropdownOpen && (
//             <div className="usernavbar-language-dropdown">
//               <div className="usernavbar-language-option" onClick={() => handleLanguageChange('en')}>
//                 {t('navbar.english')}
//               </div>
//               <div className="usernavbar-language-option" onClick={() => handleLanguageChange('bn')}>
//                 {t('navbar.bangla')}
//               </div>
//             </div>
//           )}
//         </div>

//         {user && <NotificationDropdown />}
//         {user ? (
//           <div className="usernavbar-profile" onClick={toggleDropdown}>
//             <img
//               src={user?.image ? `${URL}${user.image}` : userpic}
//               alt="User"
//               className="usernavbar-userpic"
//             />
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-dropdown-icon ${dropdownVisible ? "open" : ""}`}
//             />
//             {dropdownVisible && (
//               <div className="usernavbar-submenu-wrap active">
//                 <div className="usernavbar-submenu">
//                   {/* User Info Section */}
//                   <div className="usernavbar-user-info">
//                     <img
//                       src={user?.image ? `${URL}${user.image}` : userpic}
//                       alt="User"
//                       className="usernavbar-submenu-userpic"
//                     />
//                     <div className="usernavbar-user-details">
//                       <Textfit mode="single" max={16}>
//                         {user.FirstName + " " + user.LastName}
//                       </Textfit>
//                       {user.Email && (
//                         <p className="usernavbar-submenu-email">{user.Email}</p>
//                       )}
//                     </div>
//                   </div>
//                   <hr />

//                   {/* Menu Items */}
//                   <Link to="/profile" className="usernavbar-submenu-link">
//                     <img src={profile} alt="Profile" />
//                     <p>{t('navbar.profile')}</p> {/* Line 197: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={setting} alt="Settings" />
//                     <p>{t('navbar.settings')}</p> {/* Line 201: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <Link to="#" className="usernavbar-submenu-link">
//                     <img src={help} alt="Help" />
//                     <p>{t('navbar.help')}</p> {/* Line 205: Use translation */}
//                     <span>&gt;</span>
//                   </Link>
//                   <hr />

//                   {/* Logout */}
//                   <div
//                     className="usernavbar-submenu-link usernavbar-submenu-logout"
//                     onClick={handleLogout}
//                   >
//                     <img src={Logout} alt="Logout" />
//                     <p>{t('navbar.logout')}</p> {/* Line 215: Use translation */}
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         ) : (
//           <Link to="/login">
//             <button className="usernavbar-login-btn">{t('navbar.login')}</button> {/* Line 222: Use translation */}
//           </Link>
//         )}
//       </div>

//       {/* CHANGED: Added usernavbar-mobile-only class to sidebar menu */}
//       <ul
//         className={
//           sideMenuOpen ? "usernavbar-side-menu open usernavbar-mobile-only" : "usernavbar-side-menu usernavbar-mobile-only"
//         }
//       >
//         <li>
//           <Link className="usernavbar-link" to="/home" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} />
//             <span>{t('navbar.home')}</span> {/* Line 235: Use translation */}
//           </Link>
//         </li>
//         <li>
//           <div
//             className={`usernavbar-link ${servicesDropdownOpen ? "active" : ""}`}
//             onClick={toggleServicesDropdown}
//           >
//             <FontAwesomeIcon className="usernavbar-icon" icon={faTools} />
//             <span>{t('navbar.services')}</span> {/* Line 242: Use translation */}
//             <FontAwesomeIcon
//               icon={faCaretDown}
//               className={`usernavbar-services-dropdown-icon ${
//                 servicesDropdownOpen ? "open" : ""
//               }`}
//             />
//           </div>
//           {servicesDropdownOpen && (
//             <ul className={`usernavbar-services-dropdown ${servicesDropdownOpen ? "open" : ""}`}>
//               <li>
//                 <Link
//                   to="/services/electrician"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faWrench}
//                   />
//                   <span>{t('navbar.electrician')}</span> {/* Line 260: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/home-cleaning"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faBroom}
//                   />
//                   <span>{t('navbar.home_cleaning')}</span> {/* Line 272: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/plumber"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faFaucet}
//                   />
//                   <span>{t('navbar.plumber')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/gas-chula"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faFire}
//                   />
//                   <span>{t('navbar.gas_chula')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/ac-service"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faSnowflake}
//                   />
//                   <span>{t('navbar.ac_service')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/filter"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faFilter}
//                   />
//                   <span>{t('navbar.filter')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//               <li>
//                 <Link
//                   to="/services/tutor-service"
//                   className="usernavbar-services-link"
//                   onClick={handleServiceSelect}
//                 >
//                   <FontAwesomeIcon
//                     className="usernavbar-services-icon"
//                     icon={faUserGraduate}
//                   />
//                   <span>{t('navbar.tutor_service')}</span> {/* Line 284: Use translation */}
//                 </Link>
//               </li>
//             </ul>
//           )}
//         </li>

//         <li>
//           <Link
//             className="usernavbar-link"
//             to="/earnwithHelpNao"
//             onClick={toggleSideMenu}
//           >

//             <FontAwesomeIcon
//               className="usernavbar-icon"
//               icon={faBangladeshiTakaSign} // uses sack-dollar if available, else money-bill-wave
//             />
//             <span>{t('navbar.start_earning') || 'Start earning'}</span>
//           </Link>
//         </li>

//         <li>
//           <Link
//             className="usernavbar-link"
//             to="/about"
//             onClick={toggleSideMenu}
//           >
//             <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} />
//             <span>{t('navbar.about')}</span> {/* Line 296: Use translation */}
//           </Link>
//         </li>
//         <li>
//           <Link className="usernavbar-link" to="/helpfaqs" onClick={toggleSideMenu}>
//             <FontAwesomeIcon className="usernavbar-icon" icon={faEnvelope} />
//             <span>{t('navbar.faq')}</span> {/* Line 301: Use translation */}
//           </Link>
//         </li>
//       </ul>

//       {sideMenuOpen && (
//         <div
//           className="usernavbar-overlay open"
//           onClick={closeAllOverlays}
//           aria-hidden="true"
//         />
//       )}
//     </nav>
//   );
// };

// export default Navbar;








// ***** New Update in Navbar (3-Nov-2025) ***** //
import React, { useState, useEffect, useRef, useCallback } from 'react';
import './navbarstyle.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faInfoCircle,
  faTools,
  faEnvelope,
  faBars,
  faTimes,
  faCaretDown,
  faWrench,
  // faBroom,
  faFaucet,
  faGlobe,
  faFire,
  faSnowflake,
  // faFilter,
  // faUserGraduate,
  faBangladeshiTakaSign,
  faEllipsisV,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';
import { Textfit } from 'react-textfit';
import userpic from './images/Usericon.png';
import profile from './images/profile.png';
// import setting from './images/setting.png';
// import help from './images/help.png';
import Logout from './images/logout.png';
import { URL } from '../config';
import NotificationDropdown from '../Pages/User/Notification/NotificationDropdown';
import { useTranslation } from 'react-i18next'; // Line 26: Added for i18n
import axios from 'axios'; // Line 27: Added for consistent API calls
import logoImg from '../Assets/HelpNaoLogo.png'; 

const Navbar = () => {
  const { t, i18n } = useTranslation(); // Line 30: Initialize i18n
  const [sideMenuOpen, setSideMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false); // Line 35: Added for language dropdown state
  const dropdownRef = useRef(null);
  const languageDropdownRef = useRef(null); // Line 37: Added for language dropdown ref


  // ADD: state & refs for "More"
  const servicesDropdownContainerRef = useRef(null);
  const [moreDropdownOpen, setMoreDropdownOpen] = useState(false);         // desktop More
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);                 // mobile More
  const moreDropdownRef = useRef(null);


  // Line 39-58: Memoized fetchUserDetails to fix ESLint warning
  const fetchUserDetails = useCallback(async (userId) => {
    try {
      const extractedUserId = userId.startsWith('user-')
        ? userId.split('user-')[1]
        : userId;
      const response = await axios.get(`${URL}/user/${extractedUserId}`, {
        params: { lang: i18n.language } // Pass language for translated data
      });
      if (response.status === 200) {
        const userData = response.data;
        setUser(userData);
        if (userData.language && userData.language !== i18n.language) {
          i18n.changeLanguage(userData.language); // Sync with user preference
        }
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUser(null);
    }
  }, [i18n]);

  // Line 60-66: Updated useEffect with fetchUserDetails dependency
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      fetchUserDetails(decodedToken.Id);
    }
  }, [fetchUserDetails]);

  // Line 68-85: Updated useEffect to handle both dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
      if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target)) {
        setLanguageDropdownOpen(false);
      }

      if (!sideMenuOpen) {
        if (servicesDropdownContainerRef.current &&
            !servicesDropdownContainerRef.current.contains(event.target)) {
          setServicesDropdownOpen(false);
        }
      }

      if (moreDropdownRef.current && !moreDropdownRef.current.contains(event.target)) {
        setMoreDropdownOpen(false);
      }
    };
    if (dropdownVisible || languageDropdownOpen || moreDropdownOpen  || servicesDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownVisible, languageDropdownOpen, moreDropdownOpen, servicesDropdownOpen,sideMenuOpen,
    servicesDropdownContainerRef, dropdownRef, languageDropdownRef, moreDropdownRef]);

  // Line 87-94: Added handleLanguageChange
  const handleLanguageChange = async (lang) => {
    i18n.changeLanguage(lang);
    setLanguageDropdownOpen(false);
    // if (user) {
    //   try {
    //     await axios.put(`${URL}/user/${user.Id}/language`, { language: lang }, {
    //       headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    //     });
    //   } catch (error) {
    //     console.error('Error updating language:', error);
    //   }
    // }
  };

  // Line 96-101: Handle Logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    window.location.href = '/login';
  };

  // Line 103-105: Toggle user dropdown
  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  // Line 107-109: Toggle sidebar menu
  const toggleSideMenu = () => {
    setSideMenuOpen(!sideMenuOpen);
  };

  // Line 111-113: Toggle services dropdown
  const toggleServicesDropdown = () => {
    setServicesDropdownOpen(!servicesDropdownOpen);
  };


  // ADD: toggle desktop "More"
  const toggleMoreDropdown = () => {
    setMoreDropdownOpen((v) => !v);
  };

  // ADD: handle select inside desktop/mobile "More"
  const handleMoreSelect = () => {
    setMoreDropdownOpen(false);
    setMoreMenuOpen(false);
    setSideMenuOpen(false);
  };

  // ADD: toggle mobile "More" section
  const toggleMoreMenu = () => {
    setMoreMenuOpen((v) => !v);
  };


  // Line 115-118: Close services dropdown when a service is selected
  const handleServiceSelect = () => {
    setServicesDropdownOpen(false);
    setSideMenuOpen(false);
  };

  // Line 120: Added aria-label for accessibility
  const toggleLanguageDropdown = () => {
    setLanguageDropdownOpen(!languageDropdownOpen);
  };


   // --- NEW: close all popups helper (keeps things tidy)
  const closeAllOverlays = () => {
    setSideMenuOpen(false);
    setServicesDropdownOpen(false);
    setDropdownVisible(false);
    setLanguageDropdownOpen(false);

    setMoreDropdownOpen(false);
    setMoreMenuOpen(false);
  };

  // --- NEW: lock/unlock page scroll when side menu is open
  useEffect(() => {
    if (sideMenuOpen) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [sideMenuOpen]);

  // --- NEW: close drawer with ESC key
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeAllOverlays();
    };
    if (sideMenuOpen) document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [sideMenuOpen]);

 return (
    <nav className="usernavbar">
      {/* CHANGED: Left section now contains hamburger, logo AND desktop nav links */}
      <div className="usernavbar-left">
        {/* CHANGED: Added usernavbar-mobile-only class to hamburger */}
        <div className="usernavbar-menu-icon usernavbar-mobile-only" 
        onClick={toggleSideMenu}
        role="button"
          aria-label={sideMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={sideMenuOpen}
          aria-controls="usernavbar-sidemenu"
        >
          {sideMenuOpen ? (
            <FontAwesomeIcon icon={faTimes} className="usernavbar-icon" />
          ) : (
            <FontAwesomeIcon icon={faBars} className="usernavbar-icon" />
          )}
        </div>
        {/* <h1 className="usernavbar-logo">{t('navbar.logo')}</h1> */}

        {/* HelpNao Logo */}
        {/* <Link to="/home" className="usernavbar-logo-link">
          <h1 className="usernavbar-logo">{t('navbar.logo')}</h1>
        </Link> */}

        <Link to="/" className="usernavbar-logo-link">
          <h1 className="usernavbar-logo">
            <img
              src={logoImg}
              alt="HelpNao logo"
              className="usernavbar-logo-img"
            />
            <span className="usernavbar-logo-text">
              {t('navbar.logo')}
            </span>
          </h1>
        </Link>


        {/* CHANGED: Desktop nav links moved to left section beside logo */}
        <div className="usernavbar-desktop-nav-container">
          <ul className="usernavbar-desktop-nav">
            <li>
              <Link className="usernavbar-desktop-link" to="/">
                {/* <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} /> */}
                <span>{t('navbar.home')}</span>
              </Link>
            </li>
            <li className="usernavbar-desktop-services" ref={servicesDropdownContainerRef}>
              <div
                className={`usernavbar-desktop-link ${servicesDropdownOpen ? "active" : ""}`}
                onClick={toggleServicesDropdown}
              >
                {/* <FontAwesomeIcon className="usernavbar-icon" icon={faTools} /> */}
                <span>{t('navbar.services')}</span>
                <FontAwesomeIcon
                  icon={faCaretDown}
                  className={`usernavbar-services-dropdown-icon ${
                    servicesDropdownOpen ? "open" : ""
                  }`}
                />
              </div>
              {/* CHANGED: New dropdown with unique class usernavbarlinks-dropdown */}
              {servicesDropdownOpen && (
                <ul className="usernavbarlinks-dropdown">
                  <li>
                    <Link
                      to="/services/electrician"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      {/* <FontAwesomeIcon
                        className="usernavbarlinks-dropdown-icon"
                        icon={faWrench}
                      /> */}
                      <span>{t('navbar.electrician')}</span>
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/services/home-cleaning"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      <span>{t('navbar.home_cleaning')}</span>
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/services/plumber"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      {/* <FontAwesomeIcon
                        className="usernavbarlinks-dropdown-icon"
                        icon={faFaucet}
                      /> */}
                      <span>{t('navbar.plumber')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services/gas-chula"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      {/* <FontAwesomeIcon
                        className="usernavbarlinks-dropdown-icon"
                        icon={faFaucet}
                      /> */}
                      <span>{t('navbar.gas_chula')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services/ac-service"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      {/* <FontAwesomeIcon
                        className="usernavbarlinks-dropdown-icon"
                        icon={faFaucet}
                      /> */}
                      <span>{t('navbar.ac_service')}</span>
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/services/filter"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      <span>{t('navbar.filter')}</span>
                    </Link>
                  </li> */}

                  {/* <li>
                    <Link
                      to="/services/tutor-service"
                      className="usernavbarlinks-dropdown-link"
                      onClick={handleServiceSelect}
                    >
                      <span>{t('navbar.tutor_service')}</span>
                    </Link>
                  </li> */}


                  {/* Section label + divider + link */}
                    <li className="usernavbar-dropdown-section">
                      <Link
                        to="/services/full-building"
                        className="usernavbar-dropdown-section-label"
                        onClick={handleServiceSelect}
                      >
                        {t('navbar.full_building_services')}
                      </Link>
                    </li>


                </ul>
              )}
            </li>
            
            {!user && (
            <li>
              <Link className="usernavbar-desktop-link usernavbar-cta" to="/earnwithHelpNao">
                {t('navbar.start_earning') || 'Start earning'}
              </Link>
            </li>
            )}


            {!user && (
            <li>
              <Link className="usernavbar-desktop-link" to="/about">
                {/* <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} /> */}
                <span>{t('navbar.about')}</span>
              </Link>
            </li>
            )}


            {/* <li>
              <Link className="usernavbar-desktop-link" to="/helpfaqs">
                <span>{t('navbar.faq')}</span>
              </Link>
            </li> */}

            <li className="usernavbar-desktop-more" ref={moreDropdownRef}>
                <div
                  className={`usernavbar-desktop-link ${moreDropdownOpen ? "active" : ""}`}
                  onClick={toggleMoreDropdown}
                  role="button"
                  aria-expanded={moreDropdownOpen}
                  aria-haspopup="true"
                >
                  <span>{t('navbar.more')}</span>
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    className={`usernavbar-services-dropdown-icon ${moreDropdownOpen ? "open" : ""}`}
                  />
                </div>

                {moreDropdownOpen && (
                  <ul className="usernavbarlinks-dropdown">
                    <li>
                      <Link
                        to="/helpfaqs"
                        className="usernavbarlinks-dropdown-link"
                        onClick={handleMoreSelect}
                      >
                        <span>{t('navbar.faq')}</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact"
                        className="usernavbarlinks-dropdown-link"
                        onClick={handleMoreSelect}
                      >
                        <span>{t('navbar.contact')}</span>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

          </ul>
        </div>
      </div>

      {/* Right: Language switcher, Notifications, User icon or Login button */}
      <div className="usernavbar-right" ref={dropdownRef}>
        {/* Language Switcher: Lines 141-160 */}
        <div className="usernavbar-language" ref={languageDropdownRef}>
          <div
            className="usernavbar-language-toggle"
            onClick={toggleLanguageDropdown}
            aria-label={`Select language, current: ${t(`navbar.${i18n.language}`)}`} // Accessibility
          >
            <FontAwesomeIcon icon={faGlobe} className="usernavbar-icon" />
            {/* <span>{t(`navbar.${i18n.language}`)}</span> */}
            {/* for remove navbar and set en and bn */}
            
            {/* <span>{i18n.language}</span>   */}
            <span>{i18n.language.toUpperCase()}</span>  
            <FontAwesomeIcon
              icon={faCaretDown}
              className={`usernavbar-dropdown-icon ${languageDropdownOpen ? "open" : ""}`}
            />
          </div>
          {languageDropdownOpen && (
            <div className="usernavbar-language-dropdown">
              <div className="usernavbar-language-option" onClick={() => handleLanguageChange('en')}>
                {t('navbar.english')}
              </div>
              <div className="usernavbar-language-option" onClick={() => handleLanguageChange('bn')}>
                {t('navbar.bangla')}
              </div>
            </div>
          )}
        </div>

        {user && <NotificationDropdown />}
        {user ? (
          <div className="usernavbar-profile" onClick={toggleDropdown}>
            <img
              src={user?.image ? `${URL}${user.image}` : userpic}
              alt="User"
              className="usernavbar-userpic"
            />
            <FontAwesomeIcon
              icon={faCaretDown}
              className={`usernavbar-dropdown-icon ${dropdownVisible ? "open" : ""}`}
            />
            {dropdownVisible && (
              <div className="usernavbar-submenu-wrap active">
                <div className="usernavbar-submenu">
                  {/* User Info Section */}
                  <div className="usernavbar-user-info">
                    <img
                      src={user?.image ? `${URL}${user.image}` : userpic}
                      alt="User"
                      className="usernavbar-submenu-userpic"
                    />
                    <div className="usernavbar-user-details">
                      <Textfit mode="single" max={16}>
                        {user.FirstName + " " + user.LastName}
                      </Textfit>
                      {user.Email && (
                        <p className="usernavbar-submenu-email">{user.Email}</p>
                      )}
                    </div>
                  </div>
                  <hr />

                  {/* Menu Items */}
                  <Link to="/profile" className="usernavbar-submenu-link">
                    <img src={profile} alt="Profile" />
                    <p>{t('navbar.profile')}</p> {/* Line 197: Use translation */}
                    <span>&gt;</span>
                  </Link>

                  {/* Need to updated routes or pages for future */}

                  {/* <Link to="#" className="usernavbar-submenu-link">
                    <img src={setting} alt="Settings" />
                    <p>{t('navbar.settings')}</p>
                    <span>&gt;</span>
                  </Link>
                  <Link to="#" className="usernavbar-submenu-link">
                    <img src={help} alt="Help" />
                    <p>{t('navbar.help')}</p>
                    <span>&gt;</span>
                  </Link> */}

                  <hr />

                  {/* Logout */}
                  <div
                    className="usernavbar-submenu-link usernavbar-submenu-logout"
                    onClick={handleLogout}
                  >
                    <img src={Logout} alt="Logout" />
                    <p>{t('navbar.logout')}</p> {/* Line 215: Use translation */}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <Link to="/login">
            <button className="usernavbar-login-btn">{t('navbar.login')}</button> {/* Line 222: Use translation */}
          </Link>
        )}
      </div>

      {/* CHANGED: Added usernavbar-mobile-only class to sidebar menu */}
      <ul
        className={
          sideMenuOpen ? "usernavbar-side-menu open usernavbar-mobile-only" : "usernavbar-side-menu usernavbar-mobile-only"
        }
      >
        <li>
          <Link className="usernavbar-link" to="/" onClick={toggleSideMenu}>
            <FontAwesomeIcon className="usernavbar-icon" icon={faHouse} />
            <span>{t('navbar.home')}</span> {/* Line 235: Use translation */}
          </Link>
        </li>
        <li>
          <div
            className={`usernavbar-link ${servicesDropdownOpen ? "active" : ""}`}
            onClick={toggleServicesDropdown}
          >
            <FontAwesomeIcon className="usernavbar-icon" icon={faTools} />
            <span>{t('navbar.services')}</span> {/* Line 242: Use translation */}
            <FontAwesomeIcon
              icon={faCaretDown}
              className={`usernavbar-services-dropdown-icon ${
                servicesDropdownOpen ? "open" : ""
              }`}
            />
          </div>
          {servicesDropdownOpen && (
            <ul className={`usernavbar-services-dropdown ${servicesDropdownOpen ? "open" : ""}`}>
              <li>
                <Link
                  to="/services/electrician"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faWrench}
                  />
                  <span>{t('navbar.electrician')}</span> {/* Line 260: Use translation */}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/services/home-cleaning"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faBroom}
                  />
                  <span>{t('navbar.home_cleaning')}</span>
                </Link>
              </li> */}

              <li>
                <Link
                  to="/services/plumber"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faFaucet}
                  />
                  <span>{t('navbar.plumber')}</span> 
                </Link>
              </li>
              <li>
                <Link
                  to="/services/gas-chula"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faFire}
                  />
                  <span>{t('navbar.gas_chula')}</span> {/* Line 284: Use translation */}
                </Link>
              </li>
              <li>
                <Link
                  to="/services/ac-service"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faSnowflake}
                  />
                  <span>{t('navbar.ac_service')}</span> {/* Line 284: Use translation */}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/services/filter"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faFilter}
                  />
                  <span>{t('navbar.filter')}</span>
                </Link>
              </li> */}

              {/* <li>
                <Link
                  to="/services/tutor-service"
                  className="usernavbar-services-link"
                  onClick={handleServiceSelect}
                >
                  <FontAwesomeIcon
                    className="usernavbar-services-icon"
                    icon={faUserGraduate}
                  />
                  <span>{t('navbar.tutor_service')}</span>
                </Link>
              </li> */}


              {/* Section label + divider for mobile too (clickable) */}
                <li className="usernavbar-dropdown-section">
                  <Link
                    to="/services/full-building"
                    className="usernavbar-dropdown-section-label"
                    onClick={handleServiceSelect}
                  >
                    {t('navbar.full_building_services')}
                  </Link>
                </li>


            </ul>
          )}
        </li>

        {!user && (
        <li>
          <Link
            className="usernavbar-link"
            to="/earnwithHelpNao"
            onClick={toggleSideMenu}
          >

            <FontAwesomeIcon
              className="usernavbar-icon"
              icon={faBangladeshiTakaSign} // uses sack-dollar if available, else money-bill-wave
            />
            <span>{t('navbar.start_earning') || 'Start earning'}</span>
          </Link>
        </li>
        )}

        {!user && (
        <li>
          <Link
            className="usernavbar-link"
            to="/about"
            onClick={toggleSideMenu}
          >
            <FontAwesomeIcon className="usernavbar-icon" icon={faInfoCircle} />
            <span>{t('navbar.about')}</span> {/* Line 296: Use translation */}
          </Link>
        </li>
        )}

        {/* <li>
          <Link className="usernavbar-link" to="/helpfaqs" onClick={toggleSideMenu}>
            <FontAwesomeIcon className="usernavbar-icon" icon={faEnvelope} />
            <span>{t('navbar.faq')}</span>
          </Link>
        </li> */}

        <li>
            <div
              className={`usernavbar-link ${moreMenuOpen ? "active" : ""}`}
              onClick={toggleMoreMenu}
              role="button"
              aria-expanded={moreMenuOpen}
              aria-controls="mobile-more-menu"
            >
              <FontAwesomeIcon className="usernavbar-icon" icon={faEllipsisV} />
              <span>{t('navbar.more')}</span>
              <FontAwesomeIcon
                icon={faCaretDown}
                className={`usernavbar-services-dropdown-icon ${moreMenuOpen ? "open" : ""}`}
              />
            </div>

            {moreMenuOpen && (
              <ul id="mobile-more-menu" className={`usernavbar-services-dropdown open`}>
                <li>
                  <Link
                    to="/helpfaqs"
                    className="usernavbar-services-link"
                    onClick={handleMoreSelect}
                  >
                    <FontAwesomeIcon className="usernavbar-services-icon" icon={faQuestionCircle} />
                    <span>{t('navbar.faq')}</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="usernavbar-services-link"
                    onClick={handleMoreSelect}
                  >
                    <FontAwesomeIcon className="usernavbar-services-icon" icon={faEnvelope} />
                    <span>{t('navbar.contact')}</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>


      </ul>

      {sideMenuOpen && (
        <div
          className="usernavbar-overlay open"
          onClick={closeAllOverlays}
          aria-hidden="true"
        />
      )}
    </nav>
  );
};

export default Navbar;